module.exports = __webpack_public_path__ + "static/media/diabetes-charge.158104fc.png";